(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alkaline-final-stock-conversion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.documentElement.classList.add('alk-final-stock-active');

    const sectionElement = document.currentScript?.closest('.shopify-section');
    const collectionPanel = document.querySelector('[data-alk-collection]');

    if (collectionPanel) {
      document.documentElement.classList.add('alk-landing-mode');
      const collectionHero = document.querySelector('.collection-hero');
      const productGridContainer = document.querySelector('#ProductGridContainer');
      const sectionWrapper = collectionPanel.closest('.shopify-section') || collectionPanel;

      if (collectionHero) {
        collectionHero.hidden = true;
      }

      if (productGridContainer?.parentNode) {
        productGridContainer.parentNode.insertBefore(sectionWrapper, productGridContainer);
      }

      const heroLink = collectionPanel.querySelector('[data-alk-hero-link]');
      if (heroLink && productGridContainer) {
        heroLink.addEventListener('click', (event) => {
          event.preventDefault();
          productGridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      const scrollButton = collectionPanel.querySelector('.alk-final-stock-button');
      if (scrollButton && productGridContainer) {
        scrollButton.addEventListener('click', (event) => {
          event.preventDefault();
          productGridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      const cardButtonText = collectionPanel.dataset.cardButton;
      const addCardButtons = () => {
        document.querySelectorAll('#product-grid .card-wrapper').forEach((card) => {
          const cardInformationElements = Array.from(card.querySelectorAll('.card__information'));
          const cardInformation =
            cardInformationElements.find((element) => element.offsetParent !== null) ||
            cardInformationElements[cardInformationElements.length - 1];
          const productLinks = Array.from(card.querySelectorAll('.card__heading a'));
          const productLink =
            productLinks.find((element) => element.offsetParent !== null) ||
            productLinks[productLinks.length - 1];
          if (!productLink || !cardInformation) return;
          const existingButton = card.querySelector('.alk-card-cta');
          if (existingButton) {
            if (existingButton.parentElement !== cardInformation) {
              cardInformation.appendChild(existingButton);
            }
            return;
          }
          const cardButton = document.createElement('a');
          cardButton.className = 'alk-card-cta';
          cardButton.href = productLink.href;
          cardButton.textContent = cardButtonText;
          cardInformation.appendChild(cardButton);
        });
      };

      // addCardButtons(); // disabled: theme quick-add buttons are active, avoid duplicate CTAs

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addCardButtons, { once: true });
      }

      const cardObserver = new MutationObserver(addCardButtons);
      if (productGridContainer) {
        cardObserver.observe(productGridContainer, { childList: true, subtree: true });
      }
    }

    const productPanel = document.querySelector('[data-alk-product]');

    if (productPanel) {
      const productInfo = document.querySelector('.product__info-container');
      const shortDescription = productInfo?.querySelector('.prdct-short-desc');
      const paymentMethods = productInfo?.querySelector('.product__payment');
      const assurance = productPanel.querySelector('[data-alk-product-assurance]');
      const variantSelector = productInfo?.querySelector('variant-selects');
      const inventory = productInfo
        ? Array.from(productInfo.children).find((element) => element.textContent.trim().startsWith('Availability:'))
        : null;
      const liveInventory = productInfo?.querySelector('[id^="Inventory-"]');
      if (shortDescription && paymentMethods) {
        paymentMethods.insertAdjacentElement('afterend', shortDescription);
      }
      if (inventory) {
        const limitedMessage = assurance?.querySelector('strong')?.textContent.trim();
        if (limitedMessage) {
          const renderInventoryMessage = () => {
            const liveCount = liveInventory?.textContent.trim();
            const inventoryMessage = liveCount ? `${limitedMessage} — ${liveCount}` : limitedMessage;
            inventory.replaceChildren();
              inventory.append(document.createTextNode(liveCount ? limitedMessage + ' — ' : limitedMessage));
              const liveIndicator = liveInventory?.querySelector('svg')?.cloneNode(true);
              if (liveIndicator && liveCount) {
                liveIndicator.classList.add('alk-inline-stock-dot');
                liveIndicator.setAttribute('aria-hidden', 'true');
                liveIndicator.style.marginRight = '0.45rem';
                liveIndicator.style.verticalAlign = 'middle';
                inventory.append(liveIndicator);
              }
              if (liveCount) {
                inventory.append(document.createTextNode(liveCount));
              }
            inventory.setAttribute('aria-label', inventoryMessage);
          };
          if (liveInventory) {
            liveInventory.style.setProperty('display', 'none', 'important');
            const inventoryObserver = new MutationObserver(renderInventoryMessage);
            inventoryObserver.observe(liveInventory, { childList: true, subtree: true, characterData: true });
          }
          renderInventoryMessage();
        }
      }

      if (assurance) {
        if (inventory) {
          inventory.insertAdjacentElement('afterend', assurance);
        } else if (variantSelector) {
          variantSelector.insertAdjacentElement('afterend', assurance);
        }
      }

      const stickyBuy = productPanel.querySelector('[data-alk-sticky-buy]');
      const originalAddButton = productInfo?.querySelector('.product-form__submit');
      const stickyBuyButton = stickyBuy?.querySelector('button');

      if (stickyBuy && originalAddButton && stickyBuyButton) {
        stickyBuyButton.addEventListener('click', () => originalAddButton.click());
        const addButtonObserver = new IntersectionObserver(
          ([entry]) => {
            stickyBuy.hidden = entry.isIntersecting;
          },
          { threshold: 0.2 }
        );
        addButtonObserver.observe(originalAddButton);
      }
    }

    const cartPanel = document.querySelector('[data-alk-cart]');

    if (cartPanel) {
      const cartFooter = document.querySelector('.cart__footer');
      const sectionWrapper = cartPanel.closest('.shopify-section') || cartPanel;

      if (cartFooter?.parentNode) {
        cartFooter.parentNode.insertBefore(sectionWrapper, cartFooter);
      }

      const stickyCheckout = document.querySelector('[data-alk-sticky-checkout]');
      const originalCheckoutButton = document.querySelector('.cart__checkout-button');
      const stickyCheckoutButton = stickyCheckout?.querySelector('button');

      if (stickyCheckout && originalCheckoutButton && stickyCheckoutButton) {
        stickyCheckoutButton.addEventListener('click', () => originalCheckoutButton.click());
        const checkoutObserver = new IntersectionObserver(
          ([entry]) => {
            stickyCheckout.hidden = entry.isIntersecting;
          },
          { threshold: 0.2 }
        );
        checkoutObserver.observe(originalCheckoutButton);
      }
    }

    if (sectionElement && !sectionElement.textContent.trim()) {
      sectionElement.hidden = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
